import SowingHopePage from './components/SowingHopePage';

function App() {
  return <SowingHopePage />;
}

export default App;
